module.exports = __webpack_public_path__ + "static/biennale-heavy-324e1defe534d96bb999809d86af7df9.otf";